import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { TESTIMONIALS } from "@/lib/data";
import { Reveal, Overline } from "@/components/Reveal";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const go = (d) => setI((prev) => (prev + d + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section
      id="testimonials"
      className="relative py-24 sm:py-32 lg:py-40 max-w-7xl mx-auto px-4 sm:px-8 lg:px-16"
      data-testid="testimonials-section"
    >
      <Reveal>
        <Overline testid="testimonials-overline">Love Notes</Overline>
      </Reveal>

      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid="testimonial-quote"
            >
              <p className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.18] tracking-tight text-[var(--ink)]">
                <span className="text-[var(--gold)]">“</span>
                {t.quote}
                <span className="text-[var(--gold)]">”</span>
              </p>
              <footer className="mt-8 flex items-center gap-3">
                <span className="h-px w-8 bg-[var(--gold)]" />
                <span className="font-accent text-sm tracking-[0.15em] text-[var(--ink)]">
                  {t.name}
                </span>
                <span className="text-sm text-[var(--ink-3)]">· {t.venue}</span>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="lg:col-span-4 flex lg:flex-col items-center lg:items-end gap-4 lg:gap-6">
          <div className="flex gap-3">
            <button
              onClick={() => go(-1)}
              className="h-12 w-12 rounded-full border border-[var(--border-gold)] flex items-center justify-center hover:bg-[var(--ink)] hover:text-[var(--bg)] transition-colors"
              data-testid="testimonial-prev"
              aria-label="Previous"
            >
              <ArrowLeft size={18} />
            </button>
            <button
              onClick={() => go(1)}
              className="h-12 w-12 rounded-full border border-[var(--border-gold)] flex items-center justify-center hover:bg-[var(--ink)] hover:text-[var(--bg)] transition-colors"
              data-testid="testimonial-next"
              aria-label="Next"
            >
              <ArrowRight size={18} />
            </button>
          </div>
          <div className="font-accent text-sm text-[var(--ink-3)]">
            <span className="text-[var(--gold)]">0{i + 1}</span> / 0{TESTIMONIALS.length}
          </div>
        </div>
      </div>
    </section>
  );
}
